// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"072dd11f","732":"83bfec05","824":"2dd6346f","977":"125aabd2"}[chunkId] + ".chunk.js";
};